<input class="full-width" [(ngModel)]="msisdn" (ngModelChange)="onChange($event)" (blur)="onTouched()" [disabled]="disabled" type="tel" placeholder="27831234567" name="msisdn" pattern="[0-9]+">

